import script from "./ConsentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentForm.vue?vue&type=script&setup=true&lang=js"

import "./ConsentForm.vue?vue&type=style&index=0&id=145b393a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-145b393a"]])

export default __exports__